import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { buildPubStateModelYearPath, VehicleModel } from 'client/data/models/vehicle-v2';
import { PUB_STATES } from 'client/constants/pub-states';
import { Select } from 'site-modules/lease-deals/components/deals-checker-widget/ui/select/select';

const LEASE_PUB_STATES = [PUB_STATES.NEW, PUB_STATES.NEW_USED];

function YearSelectorUI({ years = undefined }) {
  const { control, resetField, setValue } = useFormContext();
  const options = (years || []).map(y => ({ value: String(y.year), label: String(y.year) }));

  const handleYearChange = useCallback(
    newValue => {
      setValue('year', newValue, { shouldValidate: true });
      resetField('make');
      resetField('model');
    },
    [setValue, resetField]
  );

  return (
    <Controller
      name="year"
      control={control}
      rules={{ required: true }}

      render={({ field: { ref, ...restField } }) => (
        <Select
          {...restField}
          options={options}
          labelText="Year"
          toggle="Select year"
          onChange={handleYearChange}
          data-tracking-id="deal_checker_year_select"
        />
      )}
    />
  );
}

YearSelectorUI.propTypes = {
  years: PropTypes.arrayOf(PropTypes.shape({ year: PropTypes.number })),
};

export const YearSelector = connectToModel(YearSelectorUI, {
  years: bindToPath(() => buildPubStateModelYearPath(LEASE_PUB_STATES), VehicleModel),
});
